import React from 'react';
import { connect } from 'react-redux';
import TagManager from 'react-gtm-module';
import config from '../../config/config';
import get from 'lodash/get';
import moment from 'moment';

import {
  getChatNotificationsCount,
  // getCommentNotificationsCount,
} from '../../modules/notifications/notifications.creator';
import {
  alertModalService,
} from '../../services/services';

import VerifyPhonePrompt from '../VerifyPhonePromp/VerifyPhonePrompt';
import usePrevious from '../../hooks/usePrevious';
import { positions, transitions } from 'react-alert';

export const useEffects = props => {
  const {
    hasAirListings,
    currentUser,
    onGetChatNotificationsCount,
    // onGetCommentNotificationsCount,
  } = props;

  const prevHasAirListings = usePrevious(hasAirListings);
  React.useEffect(() => {
    if (currentUser && currentUser.id.uuid) {
      onGetChatNotificationsCount(currentUser.id.uuid).catch(() => {});
      // onGetCommentNotificationsCount(currentUser.id.uuid);

      // Open verify phone prompt modal
      // const phoneNumber = get(currentUser, 'attributes.profile.protectedData.phoneNumber', null);
      // const isPhoneVerified = get(currentUser, 'attributes.profile.protectedData.phoneNumberVerified', null);
      // if (phoneNumber && !isPhoneVerified && hasAirListings) {
      //   const key = `${currentUser.id.uuid}::VERIFY_PHONE_PROMPT_DATE`;
      //   const promptDate = window.localStorage.getItem(key);
      //   if (!promptDate || moment().isAfter(moment(promptDate, 'l'), 'day')) {
      //     window.localStorage.setItem(key, moment().format('l'));
      //     alertModalService.openAlertWithChildren(<VerifyPhonePrompt />);
      //   }
      // }
    }
  }, [currentUser, hasAirListings]);

  React.useEffect(() => {
    if (window && window.document && config.enabledGTMTracking && config.gtmKey) {
      const tagManagerArgs = {
        gtmId: config.gtmKey,
      };
      TagManager.initialize(tagManagerArgs);
    }
  }, []);
};

const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser,
    hasAirListings: state.user.currentUserHasAirListings,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetChatNotificationsCount: userId => dispatch(getChatNotificationsCount(userId)),
    // onGetCommentNotificationsCount: userId => dispatch(getCommentNotificationsCount(userId)),
  };
};

export const connector = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const alertOptions = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_RIGHT,
  timeout: 5000,
  offset: '30px',
  // you can also just use 'scale'
  transition: transitions.SCALE,
};
